import {CART_V2_PREFIX} from '../../common/constants';

export function isCartV2(cartId: string): boolean {
  return cartId.startsWith(CART_V2_PREFIX);
}
